import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "changelog"
    }}>{`Changelog`}</h1>
    <h2 {...{
      "id": "127-2020-08-07"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.2.7...v1.2.6",
        "parentName": "h2"
      }}>{`1.2.7`}</a>
      {` (2020-08-07)`}</h2>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Internal code cleanup (detypscriptify source code)`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Update docs, readme and other configs.`}</li>

    </ul>
    <h3 {...{
      "id": "breaking-changes-tooltip-css-and-typings"
    }}>{`'Breaking' Changes: Tooltip CSS and Typings`}</h3>
    <p>{`Decoupled the `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`tippy`}</inlineCode>
      {` CSS from the package.  This will improve future versioning of the project, and is also the recommendation set by the `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`tippy`}</inlineCode>
      {` project.  Tooltips with this new versions might look off without CSS styles, but not considering this a breaking change because you can easily add the following imports to address the issue:`}</p>
    <pre><code {...{
        "className": "language-js",
        "parentName": "pre"
      }}>{`import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css'
`}</code></pre>
    <p>{`Some rarely used typings are no longer exported (e.g. `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`Enter`}</inlineCode>
      {`, `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`Spiral`}</inlineCode>
      {`, `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`WordToStringCallback`}</inlineCode>
      {`, `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`WordEventCallback`}</inlineCode>
      {`, `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`MinMaxPair`}</inlineCode>
      {`, `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`AttributeValue`}</inlineCode>
      {`).  While this is a breaking change, taking the liberty to assume this as non-breaking in an effort to constrain the exposed typings for improved future versioning of the project.`}</p>
    <h2 {...{
      "id": "126-2020-07-21"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.2.6...v1.2.5",
        "parentName": "h2"
      }}>{`1.2.6`}</a>
      {` (2020-07-21)`}</h2>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Correctly expose typings that were missing in `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`v1.2.5`}</inlineCode>
        {`.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Fix docs deploy by adding `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`.node-version`}</inlineCode>
        {`.`}</li>

    </ul>
    <h2 {...{
      "id": "125-2020-07-21"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.2.5...v1.2.4",
        "parentName": "h2"
      }}>{`1.2.5`}</a>
      {` (2020-07-21)`}</h2>
    <p><inlineCode {...{
        "parentName": "p"
      }}>{`v1.2.4`}</inlineCode>
      {` is a working build, but it accidentally shipped `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`.docz`}</inlineCode>
      {` cache to the NPM registry...  Fix this by explicitly setting `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`files`}</inlineCode>
      {` in `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`package.json`}</inlineCode>
      {`.`}</p>
    <h2 {...{
      "id": "124-2020-07-21"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.2.4...v1.2.3",
        "parentName": "h2"
      }}>{`1.2.4`}</a>
      {` (2020-07-21)`}</h2>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Added `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`...rest`}</inlineCode>
        {` props (@davidjb)`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Added `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`tooltipOptions`}</inlineCode>
        {` to `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`options`}</inlineCode>
        {` (@davidjb) to configure `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`tippy`}</inlineCode>
        {` tooltips.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Added `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`svgAttributes`}</inlineCode>
        {` and `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`textAttributes`}</inlineCode>
        {` to `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`options`}</inlineCode>
        {` to configure attributes on `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`svg`}</inlineCode>
        {` and `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`text`}</inlineCode>
        {` nodes.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Development: updated dependencies, XO lint rules, use absolute imports with `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`~`}</inlineCode>
        {`, spaces over tabs, `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`microbundle`}</inlineCode>
        {` over `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`rollup`}</inlineCode>
        {`, `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`npm`}</inlineCode>
        {` over `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`yarn`}</inlineCode>
        {`.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Updated docs`}</li>

    </ul>
    <h2 {...{
      "id": "123-2020-05-02"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.2.3...v1.2.2",
        "parentName": "h2"
      }}>{`1.2.3`}</a>
      {` (2020-05-02)`}</h2>
    <p>{`Add `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`randomSeed`}</inlineCode>
      {` option to provide and control a seed for the random function when `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`deterministic`}</inlineCode>
      {` option is set to `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`true`}</inlineCode>
      {`.`}</p>
    <h2 {...{
      "id": "122-2020-03-14"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.2.2...v1.2.1",
        "parentName": "h2"
      }}>{`1.2.2`}</a>
      {` (2020-03-14)`}</h2>
    <h3 {...{
      "id": "typescript-fix"
    }}>{`Typescript fix`}</h3>
    <p>{`Fix incorrect `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`'linearl'`}</inlineCode>
      {` literal type value for `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`Scale`}</inlineCode>
      {`.`}</p>
    <h2 {...{
      "id": "121-2020-03-13"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.2.0...v1.2.1",
        "parentName": "h2"
      }}>{`1.2.1`}</a>
      {` (2020-03-13)`}</h2>
    <p>{`Cleanup and fix `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`index.d.ts`}</inlineCode>
      {`.`}</p>
    <h2 {...{
      "id": "120-2020-03-07"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.1.1...v1.2.0",
        "parentName": "h2"
      }}>{`1.2.0`}</a>
      {` (2020-03-07)`}</h2>
    <p>{`This release is largely internal refactoring and updating dependencies, as well as 'de-typescripting' the codebase`}</p>
    <h3 {...{
      "id": "api-additions"
    }}>{`API additions:`}</h3>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Improve rendering performance for larger clouds and multiple cloud instances with the `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`options.enableOptimizations`}</inlineCode>
        {` flag.`}</li>

    </ul>
    <h3 {...{
      "id": "small-typescript-breaking-changes"
    }}>{`Small Typescript breaking changes:`}</h3>
    <ul>

      <li {...{
        "parentName": "ul"
      }}><inlineCode {...{
          "parentName": "li"
        }}>{`Spiral`}</inlineCode>
        {` and `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`Scale`}</inlineCode>
        {` enums are removed in favor of whitelisted string values. As part of moving to ambient declarations, these enums will not materialize in the compiled code.`}</li>

    </ul>
    <h3 {...{
      "id": "internal-code-changes"
    }}>{`Internal code changes:`}</h3>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Update underlying dependencies via `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`yarn upgrade --latest`}</inlineCode>
        {`. Remove a ton of unneeded dependencies and correctly move `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`@types/*`}</inlineCode>
        {` deps to `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`devDependencies`}</inlineCode>
        {`.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Remove custom `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`eslint`}</inlineCode>
        {`, `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`prettier`}</inlineCode>
        {` config and use `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`xo`}</inlineCode>
        {` for a simpler linting setup.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Add `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`husky`}</inlineCode>
        {` pre-push hook.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Update and improve documentation with `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`docz@2.2.0`}</inlineCode>
        {`. Improved various doc pages (`}
        <inlineCode {...{
          "parentName": "li"
        }}>{`Common Issues`}</inlineCode>
        {`) and added the `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`Optimizations`}</inlineCode>
        {` and `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`Home`}</inlineCode>
        {` page`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Take the approach in various projects (e.g. `}
        <a {...{
          "href": "https://github.com/mrdoob/three.js/",
          "parentName": "li"
        }}>{`three`}</a>
        {`) to "de-typescript" the codebase and use `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`*.d.ts`}</inlineCode>
        {` files for typing in development. Continue to expose Typescript types to consumers.`}</li>

    </ul>
    <h2 {...{
      "id": "111-2019-09-27"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.1.0...v1.1.1",
        "parentName": "h2"
      }}>{`1.1.1`}</a>
      {` (2019-09-27)`}</h2>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Update dependencies and fix `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`eval`}</inlineCode>
        {` error in `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`seedrandom`}</inlineCode>
        {` package (`}
        <a {...{
          "href": "https://github.com/davidbau/seedrandom/issues/64",
          "parentName": "li"
        }}>{`link`}</a>
        {`).`}</li>

    </ul>
    <h2 {...{
      "id": "110-2019-09-08"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.0.8...v1.1.0",
        "parentName": "h2"
      }}>{`1.1.0`}</a>
      {` (2019-09-08)`}</h2>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Update dev configs + dependencies. Check with `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`yarn audit`}</inlineCode>
        {`.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Add documentation for `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`Options`}</inlineCode>
        {` and `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`Callbacks`}</inlineCode>
        {` props.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Remove ignored Typescript errors, and fix typings in `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`render.ts`}</inlineCode>
        {`.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Simplify code in `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`hooks.ts`}</inlineCode>
        {`.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Simplify typed code.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Expose `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`MouseEvent`}</inlineCode>
        {` object in `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`onWordClick`}</inlineCode>
        {`, `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`onWordMouseOut`}</inlineCode>
        {` and `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`onWordMouseOver`}</inlineCode>
        {` callbacks.`}</li>

    </ul>
    <h3 {...{
      "id": "minor-typescript-api-changes"
    }}>{`Minor Typescript API Changes`}</h3>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Exported Typescript types for component props have been changed slightly due to refactoring.`}</li>

    </ul>
    <h2 {...{
      "id": "108-2019-06-08"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.0.7...v1.0.8",
        "parentName": "h2"
      }}>{`1.0.8`}</a>
      {` (2019-06-08)`}</h2>
    <p>{`Correctly type optional `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`callbacks`}</inlineCode>
      {` and `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`options`}</inlineCode>
      {` props. Remove enums in favor of simpler union types.`}</p>
    <h2 {...{
      "id": "107-2019-06-08"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.0.6...v1.0.7",
        "parentName": "h2"
      }}>{`1.0.7`}</a>
      {` (2019-06-08)`}</h2>
    <p>{`Fix emitted types.`}</p>
    <h2 {...{
      "id": "106-2019-06-08"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.0.5...v1.0.6",
        "parentName": "h2"
      }}>{`1.0.6`}</a>
      {` (2019-06-08)`}</h2>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Support deterministic behavior for randomn layout and colors by configuring the `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`options.deterministic`}</inlineCode>
        {` field. This makes testing and creating fixed wordcloud views convenient.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Expose Typescript types.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Use various `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`d3-*`}</inlineCode>
        {` packages instead of importing `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`d3`}</inlineCode>
        {` entirely.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Update `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`docz`}</inlineCode>
        {` and docs. Add Codesandbox examples.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Move prettier rules from `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`.eslintrc.js`}</inlineCode>
        {` to `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`.prettierrc.js`}</inlineCode>
        {`. This supports better formatting in MDX files with VSCode.`}</li>

    </ul>
    <h2 {...{
      "id": "105-2019-03-16"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.0.4...v1.0.5",
        "parentName": "h2"
      }}>{`1.0.5`}</a>
      {` (2019-03-16)`}</h2>
    <h3 {...{
      "id": "new"
    }}>{`New`}</h3>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Added `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`FAQ`}</inlineCode>
        {` page explaining common 'bugs', and updated `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`Options`}</inlineCode>
        {` page with more examples`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Handled recursive attempts to layout 'bad' clouds. Provide a console warning when max attempts have been made to layout 'bad' clouds.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Changed default `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`minSize`}</inlineCode>
        {` and `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`options.fontSizes`}</inlineCode>
        {` value to make things less buggy.`}</li>

    </ul>
    <h3 {...{
      "id": "bug-fixes"
    }}>{`Bug fixes`}</h3>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Fixed a bug where `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`rotationAngles`}</inlineCode>
        {` was mutated.`}</li>

    </ul>
    <h2 {...{
      "id": "104-2019-03-16"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.0.3...v1.0.4",
        "parentName": "h2"
      }}>{`1.0.4`}</a>
      {` (2019-03-16)`}</h2>
    <p>{`Improve and simplify React hooks code after detailed understanding of: `}
      <a {...{
        "href": "https://overreacted.io/a-complete-guide-to-useeffect/",
        "parentName": "p"
      }}>{`https://overreacted.io/a-complete-guide-to-useeffect/`}</a></p>
    <h3 {...{
      "id": "bug-fixes-1"
    }}>{`Bug fixes`}</h3>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Handle words that don't fit in the boundary of the SVG by applying a font-size scale factor`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Handle large number of words`}</li>

    </ul>
    <h2 {...{
      "id": "103-2019-03-14"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.0.2...v1.0.3",
        "parentName": "h2"
      }}>{`1.0.3`}</a>
      {` (2019-03-14)`}</h2>
    <h3 {...{
      "id": "bug-fixes-2"
    }}>{`Bug fixes`}</h3>
    <ul>

      <li {...{
        "parentName": "ul"
      }}><a {...{
          "href": "https://github.com/chrisrzhou/react-wordcloud/issues/5",
          "parentName": "li"
        }}>{`https://github.com/chrisrzhou/react-wordcloud/issues/5`}</a></li>


      <li {...{
        "parentName": "ul"
      }}><a {...{
          "href": "https://github.com/chrisrzhou/react-wordcloud/issues/11",
          "parentName": "li"
        }}>{`https://github.com/chrisrzhou/react-wordcloud/issues/11`}</a></li>

    </ul>
    <p>{`Tooltip bug is fixed by programmatically creating and destroying the `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`tippy`}</inlineCode>
      {` instance. Word implosion and missing words are related to `}
      <a {...{
        "href": "https://github.com/jasondavies/d3-cloud/issues/36",
        "parentName": "p"
      }}>{`https://github.com/jasondavies/d3-cloud/issues/36`}</a>
      {`, and is fixed with a recursive solution.`}</p>
    <h2 {...{
      "id": "102-2019-03-06"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.0.1...v1.0.2",
        "parentName": "h2"
      }}>{`1.0.2`}</a>
      {` (2019-03-06)`}</h2>
    <p>{`Thanks to @warlock for transferring the NPM `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`react-wordcloud`}</inlineCode>
      {` to me!
Updating `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`package.json`}</inlineCode>
      {` and pushing package to NPM.`}</p>
    <h2 {...{
      "id": "101-2019-03-06"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v1.0.0...v1.0.1",
        "parentName": "h2"
      }}>{`1.0.1`}</a>
      {` (2019-03-06)`}</h2>
    <p>{`Change `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`word.count`}</inlineCode>
      {` to `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`word.key`}</inlineCode>
      {` because the weight of the word could be a float.`}</p>
    <h2 {...{
      "id": "100-2019-03-03"
    }}><a {...{
        "href": "https://github.com/chrisrzhou/react-wordcloud/compare/v0.1.1...v1.0.0",
        "parentName": "h2"
      }}>{`1.0.0`}</a>
      {` (2019-03-03)`}</h2>
    <h3 {...{
      "id": "features"
    }}>{`Features`}</h3>
    <p>{`As part of learning and ramping up with better JS tools and frameworks, v1.0.0 is a modern rewrite that focuses on:`}</p>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Simplifying and decoupling React/D3 code with React hooks.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Document examples with `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`docz`}</inlineCode>
        {`.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Typescript support.`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Minimize build size with `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`rollup`}</inlineCode>
        {` and `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`bundlesize`}</inlineCode>
        {`.`}</li>

    </ul>
    <h3 {...{
      "id": "breaking-changes"
    }}>{`Breaking Changes`}</h3>
    <p>{`Compared to v0, there are a number of breaking changes.`}</p>
    <ul>

      <li {...{
        "parentName": "ul"
      }}><strong {...{
          "parentName": "li"
        }}>{`React Dependency`}</strong>
        {`: You need at least `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`react^16.8.3`}</inlineCode>
        {` installed to access hook functionality.`}</li>


      <li {...{
        "parentName": "ul"
      }}><strong {...{
          "parentName": "li"
        }}>{`Features`}</strong>
        {`: Most features of the component still remain the same (e.g. tooltips, min/max font size, responsive).`}</li>


      <li {...{
        "parentName": "ul"
      }}><strong {...{
          "parentName": "li"
        }}>{`Props`}</strong>
        {`: Many v0 props have been merged into `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`options`}</inlineCode>
        {` and `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`callbacks`}</inlineCode>
        {` with potentially different names.`}</li>


      <li {...{
        "parentName": "ul"
      }}><strong {...{
          "parentName": "li"
        }}>{`Development`}</strong>
        {`: Previous developments were done in `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`flow`}</inlineCode>
        {` and a lot of dev dependencies have changed. The scripts in `}
        <inlineCode {...{
          "parentName": "li"
        }}>{`package.json`}</inlineCode>
        {` should help handle most of these changes.`}</li>

    </ul>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      